import React, { useState, useEffect } from 'react';
import './GestionPartenaires.css';
import DashboardHeader from '../../components/DashboardHeader';
import AdminNavigationBar from '../../components/AdminNavigationBar';

function GestionPartenaires() {
  const [partenaires, setPartenaires] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingPartenaire, setEditingPartenaire] = useState(null);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    nom: '',
    description: '',
    logo: null,
    site_web: '',
    email: '',
    telephone: '',
    adresse: '',
    type_partenariat: 'entreprise',
    date_debut: '',
    date_fin: '',
    actif: true,
    ordre: 0
  });

  const typesPartenariat = {
    'entreprise': 'Entreprise',
    'institution': 'Institution',
    'ong': 'ONG',
    'gouvernement': 'Gouvernement',
    'international': 'International',
    'academique': 'Académique',
    'financier': 'Financier',
    'technique': 'Technique'
  };

  useEffect(() => {
    fetchPartenaires();
  }, []);

  const fetchPartenaires = async () => {
    try {
      setLoading(true);
      const response = await fetch('http://127.0.0.1:8000/api/v1/admin/partenaires');
      const data = await response.json();
      
      if (response.ok) {
        setPartenaires(data.data || data || []);
      } else {
        console.error('Erreur lors du chargement des partenaires');
      }
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const formDataToSend = new FormData();
    Object.keys(formData).forEach(key => {
      if (key === 'logo') {
        // Ajouter le logo SEULEMENT s'il existe et est un fichier
        if (formData[key] && formData[key] instanceof File) {
          formDataToSend.append(key, formData[key]);
        }
      } else if (key === 'actif') {
        // Convertir le booléen en string
        formDataToSend.append(key, formData[key] ? '1' : '0');
      } else {
        formDataToSend.append(key, formData[key]);
      }
    });

    try {
      const url = editingPartenaire 
        ? `http://127.0.0.1:8000/api/v1/admin/partenaires/${editingPartenaire.id}`
        : 'http://127.0.0.1:8000/api/v1/admin/partenaires';
      
      // Pour les mises à jour avec FormData, utiliser POST avec _method
      if (editingPartenaire) {
        formDataToSend.append('_method', 'PUT');
      }
      
      const response = await fetch(url, {
        method: 'POST',
        body: formDataToSend
      });

      const data = await response.json();

      if (response.ok) {
        alert(editingPartenaire ? 'Partenaire modifié avec succès!' : 'Partenaire créé avec succès!');
        setShowModal(false);
        resetForm();
        fetchPartenaires();
      } else {
        console.error('Erreur réponse:', data);
        alert('Erreur: ' + (data.message || 'Une erreur est survenue'));
      }
    } catch (error) {
      console.error('Erreur complète:', error);
      alert(`Erreur lors de la sauvegarde: ${error.message}`);
    }
  };

  const handleEdit = (partenaire) => {
    setEditingPartenaire(partenaire);
    setFormData({
      nom: partenaire.nom,
      description: partenaire.description || '',
      logo: null,
      site_web: partenaire.site_web || '',
      email: partenaire.email || '',
      telephone: partenaire.telephone || '',
      adresse: partenaire.adresse || '',
      type_partenariat: partenaire.type_partenariat,
      date_debut: partenaire.date_debut || '',
      date_fin: partenaire.date_fin || '',
      actif: partenaire.actif,
      ordre: partenaire.ordre
    });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Êtes-vous sûr de vouloir supprimer ce partenaire ?')) {
      return;
    }

    try {
      const response = await fetch(`http://127.0.0.1:8000/api/v1/admin/partenaires/${id}`, {
        method: 'DELETE'
      });

      if (response.ok) {
        alert('Partenaire supprimé avec succès!');
        fetchPartenaires();
      } else {
        alert('Erreur lors de la suppression');
      }
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors de la suppression');
    }
  };

  const toggleActif = async (id) => {
    try {
      const response = await fetch(`http://127.0.0.1:8000/api/v1/admin/partenaires/${id}/toggle-actif`, {
        method: 'POST'
      });

      if (response.ok) {
        fetchPartenaires();
      } else {
        alert('Erreur lors de la modification du statut');
      }
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors de la modification du statut');
    }
  };

  const resetForm = () => {
    setFormData({
      nom: '',
      description: '',
      logo: null,
      site_web: '',
      email: '',
      telephone: '',
      adresse: '',
      type_partenariat: 'entreprise',
      date_debut: '',
      date_fin: '',
      actif: true,
      ordre: 0
    });
    setEditingPartenaire(null);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    
    if (type === 'file') {
      setFormData(prev => ({ ...prev, [name]: files[0] }));
    } else if (type === 'checkbox') {
      setFormData(prev => ({ ...prev, [name]: checked }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  return (
    <div className="admin-layout">
      <DashboardHeader />
      <AdminNavigationBar 
        title="Gestion des Partenaires" 
        onBack={() => window.navigateTo && window.navigateTo('admin-dashboard')}
      />
      <div className="admin-container">
        <main className="admin-content admin-content-full">
          <div className="partenaires-content">
            <div className="page-header">
              <button 
                className="btn-primary"
                onClick={() => {
                  resetForm();
                  setShowModal(true);
                }}
              >
                + Nouveau Partenaire
              </button>
            </div>

            {loading ? (
              <div className="loading-container">
                <div className="loading-spinner"></div>
                <p>Chargement des partenaires...</p>
              </div>
            ) : (
              <div className="partenaires-table-card">
                <table className="partenaires-table">
                  <thead>
                    <tr>
                      <th>Logo</th>
                      <th>Nom</th>
                      <th>Type</th>
                      <th>Contact</th>
                      <th>Statut</th>
                      <th>Ordre</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {partenaires.map((partenaire) => (
                      <tr key={partenaire.id}>
                        <td>
                          <div className="partenaire-logo-mini">
                            {partenaire.logo ? (
                              <img 
                                src={`http://127.0.0.1:8000/storage/${partenaire.logo}`} 
                                alt={partenaire.nom}
                                onError={(e) => {
                                  e.target.style.display = 'none';
                                  e.target.nextSibling.style.display = 'flex';
                                }}
                              />
                            ) : null}
                            <div className="logo-placeholder-mini" style={{display: partenaire.logo ? 'none' : 'flex'}}>
                              {partenaire.nom.charAt(0)}
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="partenaire-info-mini">
                            <strong>{partenaire.nom}</strong>
                            {partenaire.description && (
                              <small>{partenaire.description.substring(0, 50)}...</small>
                            )}
                          </div>
                        </td>
                        <td>
                          <span className="type-badge">
                            {typesPartenariat[partenaire.type_partenariat]}
                          </span>
                        </td>
                        <td>
                          <div className="contact-info">
                            {partenaire.email && <div>📧 {partenaire.email}</div>}
                            {partenaire.telephone && <div>📞 {partenaire.telephone}</div>}
                            {partenaire.site_web && (
                              <div>
                                🌐 <a href={partenaire.site_web} target="_blank" rel="noopener noreferrer">
                                  Site web
                                </a>
                              </div>
                            )}
                          </div>
                        </td>
                        <td>
                          <button
                            className={`status-toggle ${partenaire.actif ? 'active' : 'inactive'}`}
                            onClick={() => toggleActif(partenaire.id)}
                          >
                            {partenaire.actif ? 'Actif' : 'Inactif'}
                          </button>
                        </td>
                        <td>
                          <span className="ordre-badge">{partenaire.ordre}</span>
                        </td>
                        <td>
                          <div className="actions-buttons">
                            <button 
                              className="btn-edit"
                              onClick={() => handleEdit(partenaire)}
                            >
                              ✏️
                            </button>
                            <button 
                              className="btn-delete"
                              onClick={() => handleDelete(partenaire.id)}
                            >
                              🗑️
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {partenaires.length === 0 && (
                  <div className="empty-state">
                    <p>Aucun partenaire trouvé</p>
                    <button 
                      className="btn-primary"
                      onClick={() => {
                        resetForm();
                        setShowModal(true);
                      }}
                    >
                      Créer le premier partenaire
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </main>
      </div>

      {/* Modal Création/Édition */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{editingPartenaire ? 'Modifier le Partenaire' : 'Nouveau Partenaire'}</h2>
              <button className="close-btn" onClick={() => setShowModal(false)}>✕</button>
            </div>

            <form onSubmit={handleSubmit} className="partenaire-form">
              <div className="form-grid">
                <div className="form-group">
                  <label>Nom du partenaire *</label>
                  <input
                    type="text"
                    name="nom"
                    value={formData.nom}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Type de partenariat *</label>
                  <select
                    name="type_partenariat"
                    value={formData.type_partenariat}
                    onChange={handleInputChange}
                    required
                  >
                    {Object.entries(typesPartenariat).map(([value, label]) => (
                      <option key={value} value={value}>{label}</option>
                    ))}
                  </select>
                </div>

                <div className="form-group full-width">
                  <label>Description</label>
                  <textarea
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                    rows="3"
                  />
                </div>

                <div className="form-group">
                  <label>Logo</label>
                  <input
                    type="file"
                    name="logo"
                    onChange={handleInputChange}
                    accept="image/*"
                  />
                </div>

                <div className="form-group">
                  <label>Site web</label>
                  <input
                    type="url"
                    name="site_web"
                    value={formData.site_web}
                    onChange={handleInputChange}
                    placeholder="https://..."
                  />
                </div>

                <div className="form-group">
                  <label>Email</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="form-group">
                  <label>Téléphone</label>
                  <input
                    type="tel"
                    name="telephone"
                    value={formData.telephone}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="form-group full-width">
                  <label>Adresse</label>
                  <textarea
                    name="adresse"
                    value={formData.adresse}
                    onChange={handleInputChange}
                    rows="2"
                  />
                </div>

                <div className="form-group">
                  <label>Date de début</label>
                  <input
                    type="date"
                    name="date_debut"
                    value={formData.date_debut}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="form-group">
                  <label>Date de fin</label>
                  <input
                    type="date"
                    name="date_fin"
                    value={formData.date_fin}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="form-group">
                  <label>Ordre d'affichage</label>
                  <input
                    type="number"
                    name="ordre"
                    value={formData.ordre}
                    onChange={handleInputChange}
                    min="0"
                  />
                </div>

                <div className="form-group">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      name="actif"
                      checked={formData.actif}
                      onChange={handleInputChange}
                    />
                    Partenaire actif
                  </label>
                </div>
              </div>

              <div className="modal-footer">
                <button type="button" className="btn-cancel" onClick={() => setShowModal(false)}>
                  Annuler
                </button>
                <button type="submit" className="btn-primary">
                  {editingPartenaire ? 'Modifier' : 'Créer'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default GestionPartenaires;